import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { tenantHelpers } from '../tenantInfo';
import { Link, withRouter } from 'react-router-dom';
import AdminNavLinks from './admin-nav-links';
import * as authActions from '../auth/auth.actions';
import * as layoutActions from './layout.actions';
import './header.scss';
const etoUrl = process.env.ETO_BASE_URL;

export class Header extends Component {

  toggleNavbar() {
    const { layoutActions } = this.props;
    const { navbarCollapsed } = this.props.layout;
    !!navbarCollapsed ? layoutActions.expandNavBar() : layoutActions.collapseNavBar();
  }

  render() {
    const { auth, layout, settings, tenant, location } = this.props;
    const { navbarCollapsed } = layout || {};
    const { currentSession, isAuthenticated } = auth;
    const { user } = currentSession || {};
    const { newLogo } = settings || {};
    const isFetchingSettings = newLogo && newLogo.isFetching;
    const fullname = currentSession && currentSession.user && (currentSession.user.firstName + ' ' + currentSession.user.lastName);
    const { pathname } = location || {};

    let welcome = null;
    if (isAuthenticated && user && fullname) {
      welcome = <li id="AccountInfoLink">
                  Welcome, <span id="user-name">{fullname}</span>
                </li>
    }

    const tenantLogoUrl = tenant && tenant.currentTenant && tenant.currentTenant.logoUrl;
    const bypassCache = `?param=${Math.random()}`;
    const alternate = isFetchingSettings ? newLogo.oldLogoUrl : "/ssg-logo-primary-lg.png";
    const logoUrl = !!tenantLogoUrl ? tenantLogoUrl + bypassCache  : alternate;

    return (
      <nav className="navbar navbar-fixed-top navbar-inverse ng-scope" aria-label="Account">
        <div className="container-fluid">
          <div className="navbar-header">
            <div className="logo-container">
              <span className="logo-prefix"></span>
              <a href={bypassCache}><img className="logo" alt={`${tenantHelpers.getProductName()} logo`} src={logoUrl} /></a>
            </div>
            <button type="button" data-toggle="collapse" data-target="#navbar" className="navbar-toggle collapsed" onClick={e => this.toggleNavbar()}>
              <span className="sr-only">Toggle Navigation</span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>
          </div>
          <div id="navbar" className={ navbarCollapsed ? "navbar-collapse collapse" : "navbar-collapse collapse in" } data-target="nav navbar-nav">
            <AdminNavLinks pathname={pathname}/>
            <ul className="nav navbar-nav navbar-right">
               <li className="sr-only">
                 <a className="skip" href="#AccountInfoLink">
                   Skip To Menu
                 </a>
               </li>
               <li className="sr-only">
                 <a className="skip" href="#sidenav">
                   Skip To Navigation
                 </a>
               </li>
               <li className="sr-only">
                 <a className="skip" href="#view">
                   Skip To Content
                 </a>
               </li>
              {welcome}
              <li id="HelpLink">
                <Link to={`/admin-help`} target="_blank">
                  Help
                </Link>
              </li>
              <li id="eto-link">
                <a href={etoUrl}>
                  Return to ETO
                </a>
              </li>
              {/*
              <li>
                <a href="#" ng-click="setLang('en')">
                  English
                </a>
              </li>
              <li>
                <a href="#" ng-click="setLang('es')">
                  Español
                </a>
              </li>
              */}
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

Header.propTypes = {
  auth: PropTypes.any.isRequired,
  tenant: PropTypes.any.isRequired
};

const mapDispatchToProps = (dispatch) => {
  return {
    authActions: bindActionCreators(authActions, dispatch),
    layoutActions: bindActionCreators(layoutActions, dispatch)
  }
}

const mapStateToProps = ({ routing, auth, layout, settings, tenant }) => {
  return {
    auth,
    routing,
    layout,
    settings,
    tenant
  }
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));


